import { formatDate, formatDisplayDate } from "../../utils/formatDateDisplay";

const colorMap: Record<string, string> = {
  password: "bg-red-400",
  email_otp: "bg-green-900",
  google: "bg-blue-900",
};

export function AuthListRender(data: any) {
  return (
    <div className="flex flex-wrap gap-2 mt-3">
      {data?.data?.authStrategy?.length
        ? data.data.authStrategy.map((item: string, index: number) => {
            const key = item?.toLowerCase();
            const bgColor = colorMap[key] || "bg-gray-400";

            return (
              <span
                key={index}
                className={`text-white text-xs font-semibold px-2 rounded-sm ${bgColor}`}
              >
                {item}
              </span>
            );
          })
        : "-"}
    </div>
  );
}

export function CreatedAtRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-1">
      <p>{formatDate(data.data.createdAt)}</p>
    </div>
  );
}
export function UpdatedAtRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-1">
      <p>{formatDate(data.data.updatedAt)}</p>
    </div>
  );
}
